export default __webpack_public_path__ + "static/media/image7.8c02616f.png";